/**
 * Beans V2++ Content
 * 集中管理 Stories（12 篇）與 FAQ（12 題）資料
 * 對齊舊版 ShopPage CoffeeBeanGuide + FAQ
 */

export interface BeansStory {
  title: string
  content: string
}

export interface BeansFAQ {
  q: string
  a: string
}

export const beansStories: BeansStory[] = [
  {
    title: '咖啡豆網購怎麼選？從風味與烘焙度開始',
    content:
      '第一次咖啡豆網購，建議先從自己喜歡的風味下手：喜歡果香與花香，可以選擇淺中焙的衣索比亞、瓜地馬拉；偏好厚實可可與堅果調性，則適合中深焙的哥倫比亞或配方豆。ONGU Coffee 會在每支咖啡豆標示產區、處理法與風味描述，幫助你在線上也能精準選豆。',
  },
  {
    title: '為什麼選擇 ONGU Coffee 精品咖啡豆？',
    content:
      'ONGU Coffee 堅持使用高品質精品咖啡生豆，並以小量現烘的方式控管新鮮度，每一批咖啡豆都經過杯測確認風味穩定。從生豆挑選、烘焙曲線到包裝出貨，我們都以職人標準完成，只為了讓你在家沖煮時，也能喝到如同咖啡館等級的香氣與層次。',
  },
  {
    title: '適合在家手沖、義式濃縮與冷萃的咖啡豆推薦',
    content:
      '如果你主要是手沖咖啡，建議選擇中淺焙或帶明亮酸質的單品咖啡豆；若家中有義式咖啡機，則可以挑選中深焙、焦糖與巧克力調性的配方豆，萃取出厚實油脂與醇苦平衡的濃縮；喜歡冷萃咖啡的話，酸甜均衡、乾淨度高的精品咖啡豆會是最適合網購帶回家常備的選擇。',
  },
  {
    title: '咖啡豆網購比超市更好的地方',
    content:
      '在超市或便利商店買咖啡豆，往往看不到烘焙日期與詳細風味資訊，無法確認新鮮度。透過 ONGU Coffee 官方網站咖啡豆網購，你可以清楚知道每支咖啡豆的烘焙日期、風味輪廓與適合沖煮方式，並以專業包裝減少氧化，讓你從下單到開封，都能安心享受新鮮咖啡。',
  },
  {
    title: '咖啡豆保存與最佳風味期限',
    content:
      '咖啡豆建議放置在陰涼乾燥、避免陽光直射與高溫的環境，開封後務必確實密封。一般來說，ONGU Coffee 咖啡豆在烘焙後 7～30 天內風味表現最均衡，是手沖與義式萃取的黃金區間；妥善保存下，約可保持 2～3 個月的良好風味，不建議冷藏或冷凍反覆進出。',
  },
  {
    title: '親自到店選豆，或在家輕鬆網購',
    content:
      '如果你喜歡實際聞香、與咖啡師聊天選豆，也歡迎親自到 ONGU Coffee 門市體驗；若平常忙碌，直接在咖啡豆網購頁下單，依照產區、風味與焙度挑選，就能在家收到與門市同等品質的精品咖啡豆。無論線上或線下，我們都希望成為你日常生活中最穩定可靠的咖啡夥伴。',
  },
  {
    title: '咖啡豆怎麼挑？5 個關鍵指標一次看',
    content:
      '購買咖啡豆前請檢視 5 個關鍵指標：【一、產地】衣索比亞偏花果香、哥倫比亞偏均衡、巴西偏堅果巧克力；【二、烘焙度】淺焙顯酸甜來源高海拔豆種、深焙顯醇厚適合義式；【三、處理法】日曬金黃香甜、水洗乾淨明亮、蜜處理甜感豐滿；【四、烘焙日期】出貨時距離烘焙日不超過 7 天為佳；【五、價格】精品豆每包 200g 合理區間為 NT$400-800，過低謹慎品質。',
  },
  {
    title: '2026 ONGU Coffee 咖啡豆推薦 TOP 5',
    content:
      '烘豆師親選 2026 年必試 TOP 5：【第1名】衣索比亞 Chilaka BR—花香莓果、明亮酸甜；【第2名】哥倫比亞 La Esperanza—柑橘型酸、口感圓潤；【第3名】巴西 Yellow Bourbon—堅果香甜、厚實酒體；【第4名】瓜地馬拉 Antigua—黑巧克力調性、適合義式；【第5名】ONGU 職人配方豆—萃取穩定、咖啡拿鐵首選。',
  },
  {
    title: '手沖咖啡豆 vs 義式咖啡豆 怎麼選？',
    content:
      '手沖咖啡豆適合淺中焙、產區獨創風味豆（如衣索比亞、哥倫比亞），研磨偏中粗、萃取時間 2.5-3.5 分鐘，突顯酸質與香氣層次。義式咖啡豆適合中深焙配方豆，研磨細、萃取 25-30 秒，追求厚實 crema、苦甜平衡。兩者在烘焙度、研磨度與萃取參數完全不同，建議依主要沖煮方式分別購買。',
  },
  {
    title: '淺焙 / 中焙 / 深焙 咖啡豆風味對照表',
    content:
      '【淺焙】Agtron 70-90，豆色淡黃，保留產地原始果酸、花香、柑橘，酸質鮮明，適合手沖、虹吸。【中焙】Agtron 50-70，豆色棕褐，酸甜平衡、出現堅果、焦糖調性，適合手沖、虹吸壺。【深焙】Agtron 30-50，豆色深棕出油，苦甜厚實、酒體豐足、身體感強，適合義式、摩卡壺、咖啡拿鐵。',
  },
  {
    title: '衣索比亞・哥倫比亞・巴西 產區風味特色比較',
    content:
      '【衣索比亞】咖啡發源地，豆種高達 1500+ 種，以花香、莓果、柑橘顯著，代表產區：Yirgacheffe、Sidamo。【哥倫比亞】安地斯山脈地形變化大，風味均衡、酸質柔和，適合新手，代表產區：Huila、Nariño。【巴西】全球最大生產國，低酸、厚實、堅果與可可調性，適合義式拼配，代表產區：Minas Gerais。',
  },
  {
    title: '咖啡豆烘焙日期與賞味期完整解析',
    content:
      '烘焙後黃金期：【養豆期】烘焙後 0-7 天，二氧化碳釋放中，萃取不穩定，不建議飲用。【黃金期】烘焙後 7-30 天，香氣、酸質、甜度達到平衡，為最佳沖煮期。【尾段期】烘焙後 30-60 天，風味平緩仍可接受；超過 60 天明顯衰退。ONGU Coffee 出貨前 2-5 天現烘，確保顧客收到時正處黃金期。',
  },
]

export const beansFAQ: BeansFAQ[] = [
  {
    q: '咖啡豆怎麼挑？5 個關鍵指標',
    a: '挑選咖啡豆看 5 個關鍵指標：【一、產地】衣索比亞偏花香果酸、哥倫比亞偏均衡、巴西偏厚實堅果；【二、烘焙度】淺焙顯酸甜、中焙均衡、深焙厚實；【三、處理法】日曬香甜、水洗乾淨、蜜處理甜感豐滿；【四、烘焙日期】距送達不超過 7 天為佳；【五、價格】精品豆 200g 合理區間 NT$400-800。',
  },
  {
    q: '咖啡豆要不要冰？冷凍 vs 常溫保存',
    a: '咖啡豆建議常溫保存於陰涼乾燥處，密封避光即可。冷凍保存僅適合長期未開封整批，取用時需待回溫避免水氣凝結。冰箱冷藏不建議，反覆進出會造成水氣與異味污染，明顯影響風味。',
  },
  {
    q: '咖啡豆和咖啡粉差在哪？哪個比較新鮮？',
    a: '咖啡豆保留完整香氣，研磨後氧化速度加快，現磨現沖風味最佳。咖啡粉雖方便但開封後 2-3 週就會走味，香氣提前消失。建議購買咖啡豆，沖煮前再磨，可保留 80% 以上香氣層次。',
  },
  {
    q: '第一次買咖啡豆推薦哪一支？新手指南',
    a: '新手推薦從中焙的衣索比亞水洗豆或哥倫比亞水洗豆入門，風味均衡、酸度溫和、容易沖煮。預算友善，每包 200g 約 NT$500。這類豆適合手沖、義式與冷萃多種沖煮方式，容錯率高。',
  },
  {
    q: '100g / 200g 咖啡豆可以泡幾杯？',
    a: '以單杯手沖約 15-18g 咖啡豆計算，100g 可沖 6-7 杯，200g 可沖 12-13 杯。義式濃縮約 18-20g 一杯，200g 約可萃 10 杯。建議依使用頻率每 2-3 週購買 200g 包裝，確保新鮮度。',
  },
  {
    q: '咖啡豆網購會不會新鮮？ONGU 怎麼確保品質？',
    a: 'ONGU Coffee 採「出貨前 2-5 天現烘」模式，下單後才安排烘焙，確保送到顧客手中時烘焙日期在 7 天內。每包標示烘焙日期，並由 SCA 認證烘焙師把關，新鮮度與品質遠勝超市與電商現貨。',
  },
  {
    q: '咖啡豆怎麼磨？手搖 vs 電動磨豆機',
    a: '手搖磨豆機適合一天 1-2 杯的家用，價格 NT$1,000-3,000，研磨穩定度佳。電動磨豆機適合店家或多人家庭，每日 5 杯以上，價格 NT$3,000 起跳。建議選擇錐刀或平刀結構，避免葉片式刀盤造成粒徑不均。',
  },
  {
    q: '義式咖啡豆需要多久熟成才好喝？',
    a: '義式咖啡豆建議烘焙後養豆 7-14 天，讓二氧化碳釋放，萃取時 crema 更穩定、油脂更厚。淺中焙養豆 5-7 天即可使用，深焙義式建議 10-14 天表現最佳。ONGU 出貨日期會避開過新或過老階段。',
  },
  {
    q: '自家烘焙咖啡豆和大廠咖啡豆差在哪？',
    a: '自家烘焙採小批次、新鮮現烘，每批 5-10 公斤，烘焙師可依生豆狀態微調曲線。大廠採大批量自動化烘焙，每批 50-200 公斤，風味較標準化但缺乏個性。自家烘焙價格略高，但風味層次與新鮮度遠勝。',
  },
  {
    q: '精品咖啡豆和商業咖啡豆有什麼不同？',
    a: '精品咖啡豆（Specialty Coffee）需通過 SCA 杯測 80 分以上，產地、品種、處理法皆可追溯，全球僅約 5% 咖啡符合。商業豆（Commercial Coffee）著重產量與穩定供應，混拼產地，價格便宜但風味較單一。',
  },
  {
    q: '咖啡豆要存放多久才會不新鮮？',
    a: '未開封咖啡豆於陰涼處可保存 3-6 個月，但風味黃金期為烘焙後 7-30 天。開封後建議 2-3 週內喝完。超過 60 天風味明顯衰退，香氣減弱、酸質鈍化、油脂氧化產生哈喇味。',
  },
  {
    q: '手沖咖啡豆和義式咖啡豆可以互換嗎？',
    a: '可以互換但需調整參數。手沖豆用於義式機需研磨更細、粉量增加；義式豆做手沖需研磨稍粗、水溫降至 88-90°C 避免過萃。建議單品手沖選淺中焙，義式拼配選中深焙，能發揮各自最佳風味。',
  },
]
